(function () {
    'use script';

    var _module = angular.module;
    angular.guid = guid;
    angular.checksum = checksum;
    angular.module = module;
    angular.isBoolean = isBoolean;

    ///////////////////////////////////

    var crcTable = null;

    // Borrowed from: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript?page=1&tab=votes#tab-top
    function guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function checksum(str) {
        var crcTable = crcTable || (crcTable = makeCRCTable());
        var crc = 0 ^ (-1);

        for (var i = 0; i < str.length; i++)
            crc = (crc >>> 8) ^ crcTable[(crc ^ str.charCodeAt(i)) & 0xFF];

        return (crc ^ (-1)) >>> 0;
    }


    function makeCRCTable() {
        var c;
        var crcTable = [];
        for (var n = 0; n < 256; n++) {
            c = n;
            for (var k = 0; k < 8; k++)
                c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
            crcTable[n] = c;
        }
        return crcTable;
    }

    function module(name, requires, configFn) {
        var result = _module.apply(this, arguments);
        if (arguments.length > 1)
            result.enumeration = enumeration;
        return result;

        function enumeration(name, data) {
            return this.constant(name, Enum(data));
        }
    }
    
    function isBoolean(value) {
        return typeof value === 'boolean';
    }
})();